// extracted by mini-css-extract-plugin
module.exports = {"engagement_high":"#1BBB8C","engagement_neutral":"#F5A623","engagement_low":"#E54B6A","engagement_pending":"#668099","engagement_unavailable":"#E0E6EB"};